import { createReducer } from '@reduxjs/toolkit';

import getFailedImportRows from '../../thunks/jobs/getFailedImportRows';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

const getFailedImportRowsReducer = createReducer(initialState, {
  [getFailedImportRows.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getFailedImportRows.fulfilled]: (state, { payload: { data, total, ...props } }) => ({
    ...state,
    loading: false,
    data,
    total,
    ...props
  }),
  [getFailedImportRows.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
});

export default getFailedImportRowsReducer;
